import { commonRequest } from "../../../services/ApiCall";
import { Helpers } from "../../../services/Helpers";

export const fileServices ={
    fetchAllAwsFolders: async () => {
        return await commonRequest("GET",`${Helpers.URL()}/api/admin/media/list-folders`,{},Helpers.token());
    },
    fetchFolderContent: async (folder) => {
        return await commonRequest("GET",`${Helpers.URL()}/api/admin/media/list-contents?folder=${folder}`,{},Helpers.token());
    },
    deleteFile: async (filePath) => {
        // return await commonRequest("DELETE",`${Helpers.URL()}/api/admin/media/delete-file`,{ filePath },Helpers.token());
    }
}